"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Spaces;
    }
});
const _clients3 = require("@aws-sdk/client-s3");
const _GenericS3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/GenericS3/GenericS3"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Spaces = class Spaces extends _GenericS3.default {
    patchUploadReturnKey(key) {
        // Spaces for some reason, returns the Path Style URl, if the file size is more than 6MB
        // So we need to convert it to Virtual Hosted Style URL
        if (!key.startsWith(`https://${this.input.bucket}.${this.input.region}`)) {
            key = `https://${this.input.bucket}.${this.input.region}.digitaloceanspaces.com/${key.replace(`${this.input.region}.digitaloceanspaces.com/${this.input.bucket}/`, '')}`;
        }
        key = decodeURI(key);
        return key;
    }
    patchKey(key) {
        // This is to fix the existing keys which are in Path Style URL
        const pattern = `${this.input.region}.digitaloceanspaces.com/${this.input.bucket}/`;
        if (key.startsWith(pattern)) {
            key = key.replace(pattern, '');
        }
        return key;
    }
    get defaultParams() {
        var _this_input;
        return {
            Bucket: this.input.bucket,
            ACL: ((_this_input = this.input) == null ? void 0 : _this_input.acl) || 'public-read'
        };
    }
    async init() {
        const s3Options = {
            region: 'us-east-1',
            forcePathStyle: false,
            credentials: {
                accessKeyId: this.input.access_key,
                secretAccessKey: this.input.access_secret
            },
            endpoint: `https://${this.input.region || 'nyc3'}.digitaloceanspaces.com`
        };
        this.s3Client = new _clients3.S3(s3Options);
    }
    getUploadedPath(path) {
        return {
            url: `https://${this.input.bucket}.${this.input.region || 'nyc3'}.digitaloceanspaces.com/${path}`
        };
    }
    constructor(input){
        super(input), this.name = 'Spaces';
    }
};
